export default __webpack_public_path__ + "static/media/bg-problem.d67d1c44.png";